import { lazy } from "react";
import Loadable from "app/components/Loadable";
import config from "../../common/mis";

const NotFound = Loadable(lazy(() => import("./NotFound")));

const { react_Login_With_url } = config.react_loging;

const LoginAzure = Loadable(lazy(() => import("./login/loginazure")));
const LoginDefault = Loadable(lazy(() => import("./login/Login")));

const LoginComponent = react_Login_With_url === "azure" ? LoginAzure : LoginDefault;

const sessionRoutes = [
  { path: "/session/signin", element: <LoginComponent /> },
  { path: "*", element: <NotFound /> }
];

export default sessionRoutes;
